import { render, staticRenderFns } from "./add-achieve.vue?vue&type=template&id=68465e60&scoped=true"
import script from "./add-achieve.vue?vue&type=script&lang=ts"
export * from "./add-achieve.vue?vue&type=script&lang=ts"
import style0 from "./add-achieve.vue?vue&type=style&index=0&id=68465e60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68465e60",
  null
  
)

export default component.exports